// removed by extract-text-webpack-plugin
module.exports = {"header":"_2-rkA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AppHeader/style.scss
// module id = NO8v
// module chunks = 0